import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';
import {hasPermission} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';

/** Triple gate for the AI report builder: both feature flags AND INSIGHTS_READ. Shared by the chat
 * entry point, the route, and the page so the gate lives in one place. */
export function canOpenReportBuilder(): boolean {
	return (
		hasFeatureFlag('ai_report_builder') &&
		hasFeatureFlag('forecast_agent_chat') &&
		hasPermission(PERMISSION_TYPE.INSIGHTS_READ)
	);
}
